import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EnfafSelectComponent, EnfafSelectOption } from '../enfaf-select/enfaf-select.component';
import { EnfafSwitchDarkComponent } from '../enfaf-switch-dark/enfaf-switch-dark.component';
import { MessageDto } from '../../models/dto/message.dto';

/**
 * The "send a WhatsApp message" toggle + template selector + bot-info line — shared by the normal
 * class editor (course-content.component.ts, one per entry of a class's `messages` FormArray) and
 * the Clase 0 editor (admin-class-zero.component.ts, its single `message` FormGroup). Both editors
 * only ever expose one message slot per class today (the normal-class FormArray is always seeded
 * with exactly one entry and has no add/remove UI) — this component doesn't change that cardinality,
 * it just renders one slot's UI/logic in exactly one place instead of two copies.
 */
@Component({
  selector: 'app-class-message-config',
  standalone: true,
  imports: [ReactiveFormsModule, MatTooltipModule, EnfafSwitchDarkComponent, EnfafSelectComponent],
  templateUrl: './class-message-config.component.html',
  styleUrl: './class-message-config.component.scss'
})
export class ClassMessageConfigComponent {
  @Input({ required: true }) group!: FormGroup;
  @Input() messageOptions: EnfafSelectOption[] = [];
  @Input() messages: MessageDto[] = [];
  /** Differs deliberately between callers — Clase 0 fires on confirmation, a normal class on completion. */
  @Input() label = 'Enviar mensaje de Whatsapp al finalizar la clase';

  get botInfo(): string | null {
    if (!this.group.get('enabled')?.value) return null;
    const messageId = this.group.get('messageId')?.value;
    if (!messageId) return null;
    const message = this.messages.find((m) => m.messageId === messageId);
    if (!message) return null;
    return message.kommoBotId ? `Bot de Kommo: ${message.kommoBotId}` : 'Sin bot de Kommo configurado';
  }
}
